import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AssetStatus } from 'src/app/models/building.model';
import { Customer, CustomerEdit } from 'src/app/models/customer.model';
import { F11Crud } from 'src/app/models/feeder11.model';
import { F33Crud } from 'src/app/models/feeder33.model';
import { EntityType, ImageType } from 'src/app/models/image.model';
import { User } from 'src/app/models/user.model';
import { BuildingService } from 'src/app/services/building.service';
import { CustomerService } from 'src/app/services/customer.service';
import { DtService } from 'src/app/services/dt.service';
import { F11Service } from 'src/app/services/f11.service';
import { F33Service } from 'src/app/services/f33.service';
import { MeterService } from 'src/app/services/meter.service';
import { UserService } from 'src/app/services/user.service';
import { HistoryOutput } from 'src/app/models/history.model';
import { TranslationService } from 'src/app/services/translation.service';
import { PermissionsEnum } from 'src/app/models/role.model';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { PermissionsService } from 'shared-lib';
import { AssetStatusEnum } from 'src/app/models/assetStatus.model';
import { MeterType } from '../../../models/meter.model';
import { OptionObj } from 'src/app/models/util.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { ContainerNames } from 'src/app/models/containerNames.model';


@Component({
  selector: 'app-edit-onboard-customer',
  templateUrl: './edit-onboard-customer.component.html',
  styleUrls: ['./edit-onboard-customer.component.scss']
})
export class EditOnboardCustomerComponent implements OnInit {
  customer: CustomerEdit = new CustomerEdit();
  longitude: number = 0;
  latitude: number = 0;
  customerHeaderInfo: Customer = new Customer();
  PermissionsEnum = PermissionsEnum;

  AssetAssignType = AssetStatusEnum;
  assetAssignType: AssetStatusEnum;

  mobileUsers: User[] = [];
  assignedUserId: number = 0;
  buName: string = this.translationService.getByKeyFromStorage('BU');

  utName: string = this.translationService.getByKeyFromStorage('UT');

  ImageType = ImageType;
  EntityType = EntityType;
  billImage: File | null;
  buildingImage: File | null;
  selectedImage: any;
  isImageMapVisible: boolean = false;

  editEnabled: boolean = false;
  meterEditEnabled: boolean = false;
  f11Options: F11Crud[] = [];
  f33Options: F33Crud[] = [];
  dtOptions: OptionObj[] = [];
  sltStatus: string = '';
  sltOptions: OptionObj[] = [];
  meterTypeOptions: OptionObj[] = [];
  openApproveModal: boolean = false;
  openRejectModal: boolean = false;
  rejectionReason = '';
  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('closeDQModal') closeDQModal: ElementRef;
  @ViewChild('openUpdateDescriptionModal') openUpdateDescriptionModal: ElementRef;
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('userFilterInput') userFilter: ElementRef;

  history: HistoryOutput = new HistoryOutput();
  imgElement: any;
  imgZoomFullContainer: any;
  filterText: string = "";
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;
  currentRotation: number = 0;
  showSendKyc: boolean = false;
  dtName: string = this.translationService.getByKeyFromStorage('DTNumber');
  isMapVisible: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private customerService: CustomerService, private toastr: ToastrService, private meterService: MeterService,
    private buildingService: BuildingService, private userService: UserService, private f11Service: F11Service, public permissionsService: PermissionsService,
    private f33Service: F33Service, private dtService: DtService, private router: Router, private translationService: TranslationService, private el: ElementRef,
    private renderer: Renderer2, private accountKycService: AccountKycService, private analyticsService: AnalyticsService,
    private blobStorageService: BlobStorageService
  ) { }

  ngOnInit(): void {
    this.blobStorageService.setContainer(ContainerNames.Images);
    const customerId = this.activatedRoute.snapshot.paramMap.get("id");
    this.imgElement = this.el?.nativeElement?.querySelector('.ngxImageZoomThumbnail');
    this.imgZoomFullContainer = this.el?.nativeElement?.querySelector('.ngxImageZoomFull');

    this.getCustomer(customerId);
    this.getFeedersForOptions();
    this.getSltStatusesForOptions();
    this.getMeterTypesForOptions();
  }

  setModalType(type: AssetStatusEnum) {
    this.assetAssignType = type;
  }

  getMeterTypesForOptions() {
    this.meterService.getMeterTypesForOptions().subscribe(response => {
      this.meterTypeOptions = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getSltStatusesForOptions() {
    this.customerService.getSltStatusesForOptions().subscribe(response => {
      this.sltOptions = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getFeedersForOptions() {
    this.f11Service.getAllForSelect().subscribe(response => {
      this.f11Options = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });

    this.f33Service.getAllForSelect().subscribe(response => {
      this.f33Options = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getDtsForOptions(feederId: number) {
    this.dtService.getAllForSelectByFeeder(feederId, this.customer.dt?.feeder?.feederType.toString()).subscribe(response => {
      this.dtOptions = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  private getCustomer(customerId: any) {
    this.customerService.get(customerId).subscribe({
      next: response => {
      
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === "OK") {
          this.customer = new CustomerEdit(responseData.data);
          this.longitude = this.customer.building.longitude;
          this.latitude = this.customer.building.latitude;
          this.assignedUserId = this.customer.building.assignedUserId !== 0 ? this.customer.building.assignedUserId : 0;
          this.customer.feederId = this.customer.dt?.feeder?.id;
          this.customer.dtId = this.customer.dt ? this.customer.dt.id : 0;
          this.customer.meterTypeId = this.customer.meter?.meterType ? this.customer.meter?.meterType?.id : 0;
          this.customer.meterNo = this.customer.meter ? this.customer.meter.number : '';
          this.filterText = this.customer.building.assignedUser ? this.customer.building.assignedUser : '';
          this.tempAssignedUserId = this.assignedUserId;
          if (this.customer.feederId) {
            this.getDtsForOptions(this.customer.feederId);
          }
          this.formatHeaderInfo(this.customer);
          this.getMobileUsers();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: _ => {
        this.toastr.error("Error occured");
      }
    });
  }

  getMobileUsers() {
    this.userService.getMobileUsers(this.customer.area.id, this.filterText).subscribe({
      next: response => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === "OK") {
          this.mobileUsers = responseData.data;
          if (this.mobileUsers.length == 0) {
            this.isDropdownOpened = false;
          }
          else {
            this.isDropdownOpened = true;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: _ => {
        this.toastr.error("Error occured");
      }
    });
  }

  mapUseOfPremise(useOfPremise:any){
    if(useOfPremise=='ReligiousCenter')
      return 'Religious Center';
    return useOfPremise
  }
  getBuildingImageByType(imageType: string, index?: number) {
    return this.customer.buildingImages.filter(x => x.imageType === imageType)[index ?? 0];
  }

  getCustomerImageByType(imageType: string) {
    return this.customer.customerImages.find(x => x.imageType === imageType);
  }

  getBuildingMountedImage() {
    return this.customer.buildingImages.find(x => x.imageType === 'MountedTag')?.url;
  }

  getFrontViewImage(id: number) {
    return this.customer.buildingImages.filter(x => x.imageType === 'Frontview')[id]?.url;
  }

  edit() {
    this.editEnabled = true;
    this.meterEditEnabled = this.editEnabled && !!this.customer.meter.number;
  }

  save() {

    if (this.customer.meter.meterType == null) {
      this.customer.meter.meterType = new MeterType();
      this.customer.meter.meterType.id = this.customer.meterTypeId;
    } else {
      this.customer.meter.meterType.id = this.customer.meterTypeId;
    }

    this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Edit', {
      customer_id: this.customer.id
    });

    this.customerService.addCustomer(this.customer).subscribe({
      next: response => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === "OK") {
          this.openUpdateDescriptionModal?.nativeElement?.click();
          this.editEnabled = false;
          this.formatHeaderInfo(this.customer);
          window.location.reload();
          this.toastr.success("Successfully edited customer");
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: _ => {
        this.toastr.error("Error occured");
      }
    });
  }

  formatHeaderInfo(customer: CustomerEdit) {
    this.customerHeaderInfo.tenantName = customer.tenantName;
    this.customerHeaderInfo.slrn = customer.building.slrn;
    this.customerHeaderInfo.email = customer.email;
    this.customerHeaderInfo.phoneNumber = customer.phoneNumber;
    this.customerHeaderInfo.address = customer.address;
  }

  selectAssignUser(e: any) {
    this.assignedUserId = +e.target.value;
  }

  assignTask(): void {
    if (this.mobileUsers.filter(x => x.fullName == this.filterText.trim()).length > 0) {
      this.assignedUserId = this.mobileUsers.filter(x => x.fullName == this.filterText.trim())[0].id;
      this.tempAssignedUserId = this.assignedUserId;
    }
    else {
      this.tempAssignedUserId = 0
    }
    if (this.tempAssignedUserId != 0) {

      this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Assign/Retag task', {
        slrn: this.customer.building.slrn
      });
     
      this.buildingService.assignBuilding(this.customer.building.id, this.assignedUserId,
        this.assetAssignType,false).subscribe({
          next: response => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === "OK") {
              this.closeModal?.nativeElement?.click();
              this.toastr.success("Successfully assigned user");
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: _ => {
            this.toastr.error("Error occured");
          }
        });
    }
    else {
      this.toastr.warning('Please select valid user.');
    }
  }

  showImage(num: number) {
    if (num === 0) {
      this.selectedImage = this.getBuildingImageByType('Frontview', 0);
    }
    else if (num === 1) {
      this.selectedImage = this.getBuildingImageByType('Frontview', 1);
    }
    else if (num === 2) {
      this.selectedImage = this.getBuildingImageByType('Frontview', 2);
    }
    else if (num === 3) {
      this.selectedImage = this.getBuildingImageByType('MountedTag');
    }
    else if (num === 4) {
      this.selectedImage = this.getCustomerImageByType('Bill')
    }
    else if (num === 5) {
      this.selectedImage = this.getCustomerImageByType('Card')
    }
    else if (num === 6) {
      this.selectedImage = this.getCustomerImageByType('Meter')
    }
    else if (num === 7) {
      this.selectedImage = this.getCustomerImageByType('UtilitySupply')
    }
    else if (num === 8) {
      this.selectedImage = this.getCustomerImageByType('CutOutFuse')
    }
  }

  selectFeeder() {
    this.customer.dtId = 0;
    this.getDtsForOptions(this.customer.feederId);
  }

  cancelModal(event: any) {
    this.closeDQModal?.nativeElement?.click();
    if (event.isBuilding) {
      this.router.navigateByUrl(
        `/buildings/edit/${event.id}`
      );
    } else {
      if (event.isOnBoard) {
        this.router.navigateByUrl(
          `/customers/edit/${event.id}`
        );
      } else {
        this.router.navigateByUrl(
          `/customers/edit/${event.id}`
        );
      }
    }
  }

  updateStatus(event: any, type: string) {
    var status = AssetStatus.Pending;
    if (type === 'approve') 
    {
      status = AssetStatus.Complete;

      this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Approve Customer', {
        customer_id: this.customer.id
      });
    }
    else {
      status = AssetStatus.Incomplete
      
      this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Reject Customer', {
        customer_id: this.customer.id
      });
    }

    const obj = {
      customerId: this.customer.id,
      status: status,
      rejectionReason: this.rejectionReason
    }
    this.customerService.updateStatus(obj).subscribe({
      next: response => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === "OK") {
          this.toastr.success("Successfully");
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: _ => {
        this.toastr.error("Error occured");
      }
    });

  }

  disableUpdateStatusButton() {
    if (this.customer.dataQualityId === 0)
      return false;
    else
      return true;
  }

  updateHistory(history: any) {
    this.history = history;
    this.customer.history = this.history;
    this.save();
  }

  openEditModal() {
    this.openUpdateDescriptionModal?.nativeElement?.click();
  }

  onModalAssignFade() {
    this.filterText = this.customer.building.assignedUser ? this.customer.building.assignedUser : '';
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }

  openDropdown() {
    this.isDropdownOpened = true;
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find(x => x.id == id);
    this.filterText = mobUser!.fullName;
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    const clickedInside = this.isDropdownOpened && (this.dropdownContainer?.nativeElement?.contains(event.target) || this.userFilter?.nativeElement?.contains(event.target));
    if (!clickedInside) {
      this.isDropdownOpened = false;
    }
  }

  sendKycMail() {
    if (this.customer.email === undefined || this.customer.email === '') {
      this.toastr.warning("This user has no associated Email address");
    }
    this.accountKycService.sendKycEmail(this.customer.id).subscribe(res => {
      if (res.status === 200 || res.status === 'OK') {
        this.toastr.success(res.message);
      } else {
        this.toastr.error(res.message);
      }
    },
      error => {
        this.toastr.error('An error occurred.');
      });
  }

  fileBrowserHandler($event: any, type: ImageType) {
    const selectedFile = $event.target.files.item(0);
    if (!selectedFile) {
        this.toastr.error('Image data is missing');
        return;
    }

    if (this.isCustomerImageType(type)) {
        this.handleCustomerImageUpload(selectedFile, type);
    } else {
        this.handleBuildingImageUpload(selectedFile, type);
    }
  }

  private isCustomerImageType(type: ImageType): boolean {
      return type === ImageType.Bill || type === ImageType.Card ||
            type === ImageType.Meter || type === ImageType.MeterNumber || 
            type === ImageType.CardBackViewImage;
  }

  private handleCustomerImageUpload(file: File, type: ImageType) {
    this.blobStorageService.uploadFile(
        file,
        file.name,
        (response) => {
            const uploadedUrl = response;

            const obj = {
                imageType: type,
                customerId: this.customer.id,
                guid: this.customer.guid,
                url: uploadedUrl
            };

            this.customerService.uploadPicture(obj, file, this.customer.guid)
                .subscribe({
                    next: (response) => this.handleCustomerUploadResponse(response, type),
                    error: (_) => this.toastr.error('Error occurred while uploading to the server'),
                });
        },
        (error) => {  // Error callback for blob upload
            console.error("Error uploading image to blob storage:", error);
            this.toastr.error('Failed to upload image to storage');
        }
    );
  }

  private handleBuildingImageUpload(file: File, type: ImageType) {
    this.blobStorageService.uploadFile(
        file,
        file.name,
        (response) => {
            const uploadedUrl = response;

            const obj = {
                imageType: type,
                buildingId: this.customer.building.id,
                guid: this.customer.building.guid,
                url: uploadedUrl
            };

            this.buildingService.uploadPicture(obj, file)
                .subscribe({
                    next: (response) => this.handleBuildingUploadResponse(response),
                    error: (_) => this.toastr.error('Error occurred while uploading to the server'),
                });
        },
        (error) => {  // Error callback for blob upload
            console.error("Error uploading building image to blob storage:", error);
            this.toastr.error('Failed to upload building image to storage');
        }
    );
  }

  private handleCustomerUploadResponse(response: any, type: ImageType) {
      const responseData = response.body;
      if (responseData?.status === 200 || responseData?.status === 'OK') {
          switch (type) {
              case ImageType.Bill:
                  this.customer.billImageUrl = responseData.data.url;
                  break;
              case ImageType.Card:
                  this.customer.cardImageUrl = responseData.data.url;
                  break;
              case ImageType.Meter:
                  this.customer.meterImageUrl = responseData.data.url;
                  break;
              case ImageType.MeterNumber:
                  this.customer.meterNumberImageUrl = responseData.data.url;
                  break;
              case ImageType.CardBackViewImage:
                  this.customer.backCardViewImageUrl = responseData.data.url;
                  break;
          }
          this.toastr.success('Successfully added image');
      } else {
          this.toastr.error(responseData?.message);
      }
  }

  private handleBuildingUploadResponse(response: any) {
      const responseData = response.body;
      if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.customer.buildingImages.push(responseData.data);
          this.toastr.success('Successfully added image');
      } else {
          this.toastr.error(responseData?.message);
      }
  }
}
